<template>
    <BasePanel
        headline="lang_LABEL_RELEASES_PANEL_CAPTION_PROMOTIONAL_TEXTS"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                :items-per-page="100"
                class="noMinWidth"
            >
            <!-- TOP SLOT -->
                <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer>
                        <v-col cols="3">
                            <BaseButton 
                                @click="addNewRow"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
                </template>
            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.description`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-description'">
                        {{ item.description }}
                    </div>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-type'">
                        {{ $t(getType(item.type)) }}
                    </div>
                </template>
                <template v-slot:[`item.language`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-long-language'">
                        {{ $t(getLanguage(item.language)) }}
                    </div>
                </template>

            <!-- Buttons -->
                <template v-slot:[`item.delete`]="{ item }">
                    <BaseIcon 
                        @click="deleteRow(item)"
                        icon="delete"
                        color="iconDelete"
                        tooltipText="lang_GENERIC_CAPTION_DELETE"
                        :alvqa="alvqa + 'list-row-icon-delete'"
                    />
                </template>
                <template v-slot:[`item.inlineEdit`]="{ item }">
                    <BaseIcon   
                        :alvqa="alvqa + '-list-row-icon-inline-edit'"
                        icon="edit" 
                        tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"   
                        @click.stop="editInlineFunction(item)"
                    />
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from "@/components/_base/BasePanel"
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'

import { DropdownLabelReleasesPromotionalTextType } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "ReleasePromotionalTextsEditPanel",
    components: {
        BasePanel,
        BaseIcon,
        BaseButton
    },
    data() {
        return {
            alvqa: 'label-releases-edit-form-panel-digital-promotional-texts'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t('lang_LABEL_RELEASE_CAPTION_TYPE'), 
                    align: 'left',
                    value: "type",
                    class: 'text-no-wrap',
                    width: "250px",
                    sortable: false,
                    alvqa: this.alvqa + '-header-type'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_LANGUAGE'), 
                    align: 'left',
                    value: "language",
                    class: 'text-no-wrap',
                    width: "150px",
                    sortable: false,
                    alvqa: this.alvqa + '-header-language'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DESCRIPTION'), 
                    align: 'left',
                    value: "description",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-description'
                },
                {
                    text: '', 
                    value: 'inlineEdit',
                    align: 'right',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                },
                {
                    text: "",
                    align: "right",
                    width: "70px",
                    value: "delete",
                    sortable: false,
                    class: 'text-no-wrap'
                }
            ]
        },

        listItems() { return this.$store.getters.getReleasesPromotionalTexts },
    },
    methods: {
        addNewRow() {
            this.$store.commit('setShowReleasesPromotionalTextsEditingDialog', true)
            this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

            let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultReleasesPromotionalTexts)) 
            this.$store.commit('setReleasesPromotionalTextsEditingDialogDetails', defaultValues)
        },
        deleteRow(item) {
            // set the selected row that should be deleted from the delete action 
            // and open the deletion dialog
            this.$store.commit("setSelectedReleasesPromotionalTexts", item)
            this.$store.commit('setDeletionDialogContext', 'SelectedReleasesPromotionalTexts')
            this.$store.commit('setShowDeletionDialog', true)
        },
        editInlineFunction(item) {
            this.$store.commit('setSelectedReleasesPromotionalTexts', item.id)
            let detailsDeepCopy = JSON.parse(JSON.stringify(item))

            // set the copy in dialog details to edit
            this.$store.commit('setReleasesPromotionalTextsEditingDialogDetails', detailsDeepCopy)
            this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
            this.$store.commit('setShowReleasesPromotionalTextsEditingDialog', true) 
        },

        getLanguage(langugeValue) {
            let languges = this.$store.getters.getGeneralLanguages

            if(languges !== undefined) {
                return languges.find(language => {
                    return language.value === langugeValue
                }).text
            }
        },
        getType(typeValue) {
            let typeMatch = DropdownLabelReleasesPromotionalTextType.find(type => {
                return type.value === typeValue
            })

            if(typeMatch !== undefined) return typeMatch.text
        }
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>